import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CorreoCorredor {
  // Correo electronico corredores
  static async getCorreoCorredor (corredor) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_correo_corredor?r=` +
        `{"clave":{"corredor": ${corredor}},"limite":1,"orden": ["id"]}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  static enviarCuposACorredores (cupo, correoCorredor) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_cupos_a_corredores?r=` +
        `{"parametros": {"cargador": ${cupo.cargador}, "corredor": ${cupo.corredor}, "cereal": "${cupo.cereal}",
        "cantidad_asignada": ${cupo.cantidad_asignada}, "fecha_de_emision": "${cupo.fecha_de_emision}",
        "exportador": ${cupo.exportador}, "correo": "${correoCorredor}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static enviarResumenCuposACorredores (cupo, correoCorredor) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_resumen_cupos_a_corredores?r=` +
        `{"parametros": {"cargador": ${cupo.cargador}, "corredor": ${cupo.corredor},
        "cereal": "${cupo.cereal}", "exportador": ${cupo.exportador}, "correo": "${correoCorredor}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static enviarModificacionCuposACorredores (cupo, cantidadAnterior, correoCorredor) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_modificacion_cupos_a_corredores?r=` +
        `{"parametros": {"cargador": ${cupo.cargador}, "corredor": ${cupo.corredor}, "cereal": "${cupo.cereal}",
        "cantidad_anterior": ${cantidadAnterior}, "cantidad_asignada": ${cupo.cantidad_asignada}, "fecha_de_emision": "${cupo.fecha_de_emision}",
        "exportador": ${cupo.exportador}, "correo": "${correoCorredor}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static enviarTotalCuposACorredores (corredor) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_total_cupos_a_corredores?r=` +
        `{"parametros": {"corredor": ${corredor} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static eliminarCorreoCorredor (id) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`correo_corredor?r=` +
        `{"clave": {"id": ${id} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static buscarCorreoCorredor (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_contacto_corredor?r=` +
        `{"clave": {"id": ${id} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static agregarCorreoCorredor (nombre, correo, corredor) {
    const axios = getAxiosInstance()
    const promise = axios.post(`correo_corredor`,
      `{"valores": {"nombre": "${nombre}",
      "corredor": ${corredor}, "correo_electronico": "${correo}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static actualizarCorreoCorredor (id, nombre, correo, corredor) {
    const axios = getAxiosInstance()
    const promise = axios.put(`correo_corredor`,
      `{"valores": {"nombre": "${nombre}", "corredor": ${corredor}, 
      "correo_electronico": "${correo}"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static modificarCorreoCorredor (correo, corredor) {
    const axios = getAxiosInstance()
    const promise = axios.put(`modificacion_correo_corredor`,
      `{"valores": {"correo_electronico": "${correo}"}, "clave": {"corredor": ${corredor}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }
}

export default CorreoCorredor
